import React, { useState, useEffect } from 'react';
import Modal from "sushiweb/Modal";

import styles from './modals.module.scss';
import { MAX_RATING_STARS } from '../../utils/constants/others';
import { getCookieForEntity } from '../../utils/helpers';
const AccountManagerFeedbackModal = ({
  isOpen,
  onClose,
  accountManagerName = '',
  salesLeadFeedbackRating,
  updateSalesLeadFeedback,
  userId,
  salesLeadUserId,
  infoIcon = '',
  salesLeadEmail = '',
}) => {
  const [customFeedback, setCustomFeedback] = useState('');
  const [componentRating, setComponentRating] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setCustomFeedback('');
      setComponentRating(0);
    }
  }, [isOpen]);

  const handleCustomReasonChange = (e) => {
    setCustomFeedback(e.target.value);
  };

  const handleSubmit = () => {
    updateSalesLeadFeedback({
      user_id: userId,
      sales_lead_user_id: salesLeadUserId,
      rating: componentRating,
      feedback: customFeedback,
      outlet_id: parseInt(getCookieForEntity('outletId', '')) || 0,
      sales_lead_email: salesLeadEmail,
    });
    onClose();
  };

  const handleRatingClick = (starIndex) => {
    setComponentRating(starIndex);
    salesLeadFeedbackRating(starIndex, customFeedback);
  };

  const renderFooter = () => {
    const isSubmitDisabled =
      componentRating === 0 ||
      customFeedback === '' ||
      customFeedback.trim().length < 20 ||
      (customFeedback && !customFeedback.trim());
    return (
      <footer
        style={{ borderTop: '1px solid #f5f5f5', width: '93%', margin: '15px' }}
      >
        <div className={styles.infoContainer}>
          <img src={infoIcon} alt="infoIcon" className={styles.infoIcon} />
          <div className={styles.infoText}>
            This feedback won’t be shared with the account manager. It is for
            internal use only.
          </div>
        </div>
        <button
          className={`btn py-3 ${styles.submitButton}`}
          onClick={handleSubmit}
          disabled={isSubmitDisabled}
          style={{
            opacity: isSubmitDisabled ? '0.5' : '1',
          }}
        >
          Submit Feedback
        </button>
      </footer>
    );
  };

  return (
    <Modal
      visible={isOpen}
      onClose={onClose}
      titlefont="24"
      titlefontWeight="700"
      showCloseIcon={true}
      isCentered={false}
      slideOnMobile={true}
      overlayClickClose={true}
      borderRadius="24px"
      maxHeight="80vh"
      padding="16px"
      type="midScreenSize"
      bgColor="#F2F4F7"
      showFooter={isOpen}
      renderFooter={renderFooter}
      className={`${styles.AccountManagerFeedbackModal}`}
      mobileHeight={'0vh'}
    >
      <div className={styles.accountManagerName}>{accountManagerName}</div>
      <div className={styles.accountManagerSubText}>Your Account Manager</div>
      <div className={`${styles.starIconsContainer}`}>
        {Array.from({ length: MAX_RATING_STARS }, (_, i) => i + 1).map(
          (starIndex) => (
            <img
              src={
                starIndex > componentRating
                  ? 'https://assets.hyperpure.com/data/images/starWhite/starWhite1759251880.png'
                  : 'https://assets.hyperpure.com/data/images/starYellow/starYellow1759251508.png'
              }
              alt="star_icon"
              onClick={() => handleRatingClick(starIndex)}
              width={'32px'}
              height={'32px'}
            />
          ),
        )}
      </div>
      <div className="mt-2 mb-4 px-3">
        <textarea
          className={`form-control p-3 w-100 rounded ${styles.feedbackTextarea}`}
          placeholder="How has your experience been with your account manager"
          value={customFeedback}
          onChange={handleCustomReasonChange}
          rows="3"
          style={{
            backgroundColor: '#F2F4F7',
            border: '1px solid #e0e0e0',
            fontSize: '14px',
            resize: 'none',
            height: '100px',
          }}
          autoFocus
        />
        {customFeedback.trim() && customFeedback.trim().length < 20 && (
          <div style={{ color: '#EF4F5F', fontSize: '12px' }}>
            Please enter min of 20 character
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AccountManagerFeedbackModal;